import { ManualTypes, PrebuiltHintTypes } from '../Constants';

export const ManualData = {
    [ManualTypes.MISSION]: [
        {
            title: '기본 사용 방법',
            content: `<b>1.미션 확인하기</b><br/>
                작품을 실행하며 미션을 확인합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-6-1.png',
            },
        },
        {
            title: '기본 사용 방법',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-6-2.png',
            },
        },
        {
            title: '기본 사용 방법',
            content: `<b>3.[시작하기]를 눌러 결과 확인하기</b></br>
                미션에 따라 작품이 완성되었는지 확인합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-6-3.png',
            },
        },
        {
            title: '기본 사용 방법',
            content: `도움이 필요할 땐, <b>[힌트]</b>를 살펴보세요!`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-6-4.png',
            },
        },
    ],
    [ManualTypes.FREE]: [
        {
            title: '기본 사용 방법',
            content: `<b>1.미션 확인하기</b><br/>
                먼저, <span style="background-color: yellow;">미션 확인하기</span>를 통해 무엇을 해야 하는지 확인합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-free1.png',
            },
        },
        {
            title: '기본 사용 방법',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-free2.png',
            },
        },
        {
            title: '기본 사용 방법',
            content: `<b>3. 과제 제출 및 학습완료하기</b></br>
                과제인 경우 <span style="background-color: yellow;">[과제 제출]</span>버튼을 클릭하여 과제를 제출합니다.<br/>
                과제가 아닌 경우 <span style="background-color: yellow;">[학습 완료]</span>버튼을 클릭해서 학습을 완료합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-free3.png',
            },
        },
        {
            title: '기본 사용 방법',
            content: `도움이 필요할 땐, <b>[힌트]</b>를 살펴보세요!`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-free4.png',
            },
        },
    ],
};

export const PrebuiltHintData = {
    [PrebuiltHintTypes.COORDINATE]: [
        {
            type: 'PREBUILT_HINT',
            title: 'x, y 좌표 알아보기',
            content: `<b>▶ x, y 좌표 알아보기</b><br/>
                엔트리 실행화면에서 오브젝트의 위치는 '좌표'로 표현됩니다. x는 가로축의 위치를 표현하며 -240(맨왼쪽)~240(맨오른쪽)의 값을 가집니다. y는 세로축의 위치를 표현하며 -135(맨아래쪽)~135(맨위쪽)의 값을 가집니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-1-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: 'x, y 좌표 알아보기',
            content: `<b>▶ x, y 좌표 알아보기</b><br/>
                예시를 살펴 봅시다. 3개의 하트 오브젝트 
                좌표는 각각 다음과 같습니다.<br/>
                (좌표는 오브젝트의 중심점을 기준으로 
                합니다).`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-1-2.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: 'x, y 좌표 알아보기',
            content: `<b>▶ x, y 좌표 알아보기</b><br/>
                맨 왼쪽상단으로 하트를 이동시키기 위
                해 x에 -240 y에 135를 입력하면 오른쪽
                그림과 같이 하트의 모양이 다 나타나지
                않습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-1-3.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: 'x, y 좌표 알아보기',
            content: `<b>▶ x, y 좌표 알아보기</b><br/>
                좌표는 오브젝트의 중심점을 기준으로 계산되기 때문에 크기가 40인(가로40/세로40) 하트는 x에 -220, y에 115를 입력하면 맨 왼쪽상단으로 이동시킬 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-1-4.png',
            },
        },
    ],
    [PrebuiltHintTypes.SUM_BLOCK]: [
        {
            type: 'PREBUILT_HINT',
            title: "'합치기' 블록 알아보기",
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-2.png',
            },
        },
    ],
    [PrebuiltHintTypes.RANDOM_DIRECTION]: [
        {
            type: 'PREBUILT_HINT',
            title: '무작위 방향 알아보기',
            content: `<b>▶ 무작위 방향 알아보기</b><br/>
                방향을-70에서70사이의 무작위수로 정
                하면 오른쪽 그림의 범위안에서 공이 튕
                겨지게 됩니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-3.png',
            },
        },
    ],
    [PrebuiltHintTypes.ROTATE]: [
        {
            type: 'PREBUILT_HINT',
            title: '회전 방식 알아보기',
            content: `<b>▶ 회전 방식 알아보기</b><br/>
                엔트리에서는 3가지 회전방식이 있습니다. 이 회전 방식에 따라서 오브젝트가 화면 끝에 닿았을 때 오브젝트의 모양과 방향이 달라집니다.`,
        },
        {
            type: 'PREBUILT_HINT',
            title: '회전 방식 알아보기',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-4-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '회전 방식 알아보기',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-4-2.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '회전 방식 알아보기',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-4-3.png',
            },
        },
    ],
    [PrebuiltHintTypes.DIRECTION]: [
        {
            type: 'PREBUILT_HINT',
            title: '방향 알아보기',
            content: `<b>방향 알아보기</b><br/>
                엔트리에서 기본 방향은0도 입니다.
                방향의 값에 따라 달라지는 강아지의 
                모양은 오른쪽 그림과 같습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-5.png',
            },
        },
    ],
    [PrebuiltHintTypes.OBJECT]: [
        {
            type: 'PREBUILT_HINT',
            title: '오브젝트의 방향과 이동방향, 중심점 알아보기',
            content: `<b>▶ 오브젝트의 방향</b><br/>
                오브젝트의 방향이란 오브젝트가 기울어진 정도를 의미합니다. 오브젝트에 달린 방향점이 12시 방향을 가리킬 때가 0˚이고, 이를 기준으로 하여 오른쪽으로 기울일수록 늘어나다가 360˚를 돌아 처음 위치로 돌아오면 다시 0˚가 됩니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-7-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '오브젝트의 방향과 이동방향, 중심점 알아보기',
            content: `<b>▶ 오브젝트의 이동방향</b><br/>
                오브젝트의 방향점으로부터 이동방향 화살표가 이루는 각도를 의미합니다. 이동방향을 바꾸면 실제 보이는 오브젝트의 기울기에는 변화가 없고, 오브젝트가 움직이는 방향이 바뀝니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-7-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '오브젝트의 방향과 이동방향, 중심점 알아보기',
            content: `<b>▶ 오브젝트 중심점</b><br/>
                오브젝트가 회전하거나 그림을 그릴 때, 또 벽에 튕길 때 ‘중심점’이 기준이 됩니다. 특별한 의도가 없는 경우 오브젝트의 중앙에 있는 ‘중심점’을 옮기지 않도록 주의하세요!`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-7-2.png',
            },
        },
    ],
    [PrebuiltHintTypes.LAYER]: [
        {
            type: 'PREBUILT_HINT',
            title: '레이어 알아보기',
            content: `<b>▶ 레이어 조정하기</b><br/>
                오브젝트는 오브젝트 목록의 레이어 순서에 따라 상하로 배치됩니다. 레이어의 순서를 조절하여 오브젝트를 원하는 대로 배치할 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-8.png',
            },
        },
    ],
    [PrebuiltHintTypes.FOR_LOOP]: [
        {
            type: 'PREBUILT_HINT',
            title: "'반복하기' 블록 알아보기",
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-9.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'반복하기' 블록 알아보기",
            content: `<b>▶ '반복하기' 블록의 종류</b><br/>
                <span style="background-color: yellow;">1. ( )번 반복하기</span><br/>
                정해진 횟수만큼 감싸고 있는 코드를 반복실행 합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-10-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'반복하기' 블록 알아보기",
            content: `<b>▶ '반복하기' 블록의 종류</b><br/>
                <span style="background-color: yellow;">2. '~까지/동안' 반복하기</span><br/>
                조건 만족 여부에 따라 감싸고 있는 코드를 반복실행 합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-10-2.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'반복하기' 블록 알아보기",
            content: `<b>▶ '반복하기' 블록의 종류</b><br/>
                <span style="background-color: yellow;">3. 계속 반복하기</span><br/>
                감싸고 있는 코드를 계속 반복실행 합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-10-3.png',
            },
        },
    ],
    [PrebuiltHintTypes.IF_BLOCK]: [
        {
            type: 'PREBUILT_HINT',
            title: "'만일' 블록 알아보기",
            content: `<b>▶ '만일 ~이라면' 블록 사용하기</b><br/>
                상황에 따라 다른 명령을 실행하기 위해 
                <span style="background-color: yellow;">'만일 ~이라면'</span> 
                블록을 사용합니다.<br/><br/>
                1. 조건을 만족하는 경우에만 감싸고 있는 코드를 실행합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-11-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'만일' 블록 알아보기",
            content: `<b>▶ '만일 ~이라면' 블록 사용하기</b><br/>
                상황에 따라 다른 명령을 실행하기 위해 
                <span style="background-color: yellow;">'만일 ~이라면'</span> 
                블록을 사용합니다.<br/><br/>
                2. 조건을 만족하는 경우와 만족하지 않는 경우 서로 다른 코드를 실행합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-11-2.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'만일' 블록 알아보기",
            content: `<b>▶ '만일 ~이라면' 블록 사용하기</b><br/>
                상황에 따라 다른 명령을 실행하기 위해 
                <span style="background-color: yellow;">'만일 ~이라면'</span> 
                블록을 사용합니다.<br/><br/>
                3. 3가지 이상의 상황에 대해서는 만일~아니면 블록을 여러 개 중첩하여 사용합니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-11-3.png',
            },
        },
    ],
    [PrebuiltHintTypes.PROMPT]: [
        {
            type: 'PREBUILT_HINT',
            title: "'묻고 대답 기다리기' 블록 알아보기",
            content: `<b>▶ '묻고 대답 기다리기' 블록 사용하기</b><br/>
                '~를 묻고 대답 기다리기' 블록을 사용하 면 실행화면에 '대답' 창이 생성됩니다. 
                코드를 실행시키면 오브젝트가 입력한 내용을 묻고 대답을 입력할 수 있는 창이 나타납니다. 
                이렇게 입력되어 '대답 창'에 들어간 값은 
                <span style="background-color: yellow;">'대답'</span> 
                블록에 저장되어 그 값을 이용할 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-12-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: "'묻고 대답 기다리기' 블록 알아보기",
            content: `<b>▶ '묻고 대답 기다리기' 블록 사용하기</b><br/>
                '~를 묻고 대답 기다리기' 블록을 사용하 면 실행화면에 '대답' 창이 생성됩니다. 
                코드를 실행시키면 오브젝트가 입력한 내용을 묻고 대답을 입력할 수 있는 창이 나타납니다. 
                이렇게 입력되어 '대답 창'에 들어간 값은 
                <span style="background-color: yellow;">'대답'</span> 
                블록에 저장되어 그 값을 이용할 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-12-2.png',
            },
        },
    ],
    [PrebuiltHintTypes.ADD_PICTURE]: [
        {
            type: 'PREBUILT_HINT',
            title: '모양 추가 알아보기',
            content: `<b>▶ [모양] 추가하기</b><br/>
                하나의 오브젝트는 여러 가지 
                <span style="background-color: yellow;">모양</span>
                을 가질 수 있습니다. 
                여러 가지 모양으로는 애니메이션 효과를 낼 수 있습니다. 
                <span style="background-color: yellow;">[+모양 추가]</span>
                를 눌러 원하는 모양을 추가해 보세요! 카테고리 별로 오브젝트를 선택하거나, 검색기능을 사용하여 원하는 오브젝트를 추가할 수 있습니다. 또한 직접 그림을 그리거나 이미지 파일을 업로드할 수도 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-14-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '모양 추가 알아보기',
            content: `<b>▶ [모양] 추가하기</b><br/>
                하나의 오브젝트는 여러 가지 
                <span style="background-color: yellow;">모양</span>
                을 가질 수 있습니다. 
                여러 가지 모양으로는 애니메이션 효과를 낼 수 있습니다. 
                <span style="background-color: yellow;">[+모양 추가]</span>
                를 눌러 원하는 모양을 추가해 보세요! 카테고리 별로 오브젝트를 선택하거나, 검색기능을 사용하여 원하는 오브젝트를 추가할 수 있습니다. 또한 직접 그림을 그리거나 이미지 파일을 업로드할 수도 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-14-2.png',
            },
        },
    ],
    [PrebuiltHintTypes.ADD_SOUND]: [
        {
            type: 'PREBUILT_HINT',
            title: '소리 추가 알아보기',
            content: `<b>▶ [소리] 추가하기</b><br/>
                오브젝트가 소리를 내게 하려면 
                <span style="background-color: yellow;">[+소리 추가]</span>
                를 눌러 원하는 소리를 추가해야 합니다. 엔트리에서 제공하는 소리를 추가하거나, 직접 소리 파일을 업로드할 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-15-1.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '소리 추가 알아보기',
            content: `<b>▶ [소리] 추가하기</b><br/>
                오브젝트가 소리를 내게 하려면 
                <span style="background-color: yellow;">[+소리 추가]</span>
                를 눌러 원하는 소리를 추가해야 합니다. 엔트리에서 제공하는 소리를 추가하거나, 직접 소리 파일을 업로드할 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-15-2.png',
            },
        },
    ],
    [PrebuiltHintTypes.VARIABLE]: [
        {
            type: 'PREBUILT_HINT',
            title: '변수 알아보기',
            content: `<b>▶ '변수' 만들기</b><br/>
                게임에서의 '점수', 전화번호부에서 '이름'과 같은 정보들을 프로그램에 저장하기 위해 '변수'를 사용합니다. 변수를 
                <span style="background-color: yellow;">[속성]</span>
                에서 만들 수 있습니다.`,
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-13.png',
            },
        },
        {
            type: 'PREBUILT_HINT',
            title: '변수 알아보기',
            media: {
                category: 'IMAGE',
                content: '/img/assets/popup/course/img-16.png',
            },
        },
    ],
};



// WEBPACK FOOTER //
// ./static/index.js